import { useI18n } from 'modules/i18n';
import { ErrorBoundary } from 'modules/react-toolbox';
import { sanitizeHtml } from 'modules/utils';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import OrderNewPasswordFormContainer from './OrderNewPasswordFormContainer';

export default function OrderNewPassword({ orderNewPasswordStatus, error }) {
    const { t } = useI18n();

    return (
        <div className="wrapper-content register">
            <Helmet>
                <title>{t('devise.passwords.forgot')}</title>
            </Helmet>
            <ErrorBoundary>
                {orderNewPasswordStatus ? (
                    <div className="text">{t(orderNewPasswordStatus)}</div>
                ) : (
                    <div>
                        <h1 className="Page-main-title forgot-password-header">
                            {t('devise.passwords.forgot')}
                        </h1>
                        <p className="forgot-passord-text">
                            {t('devise.passwords.send_instructions')}
                        </p>
                        {error && (
                            <div
                                className="errors"
                                dangerouslySetInnerHTML={{
                                    __html: sanitizeHtml(
                                        t(error),
                                        'PLAIN_TEXT'
                                    ),
                                }}
                            />
                        )}
                        <OrderNewPasswordFormContainer />
                    </div>
                )}
            </ErrorBoundary>
        </div>
    );
}

OrderNewPassword.propTypes = {
    orderNewPasswordStatus: PropTypes.string,
    error: PropTypes.string,
};
